import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";


// extra scripts
import trompetty from "@/scripts/trompetty.js";
import routeNames from "@/router/routes/names.js";


// youfa scripts
import yfa from "@yourfutureacademy/scripts";
import config from "@/yfaConfig";

const globalFunctions = {};

// merge all functions in to globalFunctions
for (const key in trompetty) {
  if (!Object.keys(globalFunctions).includes(key)) {
    globalFunctions[key] = trompetty[key];
  } else {
    globalFunctions["trompetty" + key] = trompetty[key];
  }
}

for (const key in yfa.script) {
  if (!Object.keys(globalFunctions).includes(key)) {
    globalFunctions[key] = yfa.script[key];
  } else {
    globalFunctions["functions" + key] = yfa.script[key];
  }
}


// create app
const app = createApp(App);

// app use
app.use(router).use(store);

// app globals
app.config.globalProperties.$OTAP = config.OTAP.Value;
app.config.globalProperties.$RouteNames = routeNames;
app.config.globalProperties.$Functions = globalFunctions;

// mount app
app.mount("#app");
